import { CompanysitesService } from '../../../../company-sites/company-sites.service';
import { Component, OnInit } from '@angular/core';
import {  MatTableDataSource } from '@angular/material/table';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { combineLatest, Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { SystemService } from '../../../../../services/system.service';
import { switchMap, map } from 'rxjs/operators';
export interface PeriodicElement {
  machineCode: string;
  employeId: string;
  productId: string;
  productName: string;
  systemName: string;
  transactionId: string;
  date: string;
  status: string;
}
let ELEMENT_DATA: PeriodicElement[] = []
@Component({
  selector: 'app-t-result-view',
  templateUrl: './t-result-view.component.html',
  styleUrls: ['./t-result-view.component.css']
})

export class TResultViewComponent implements OnInit {
  transactions$;
  siteData$: Observable<any>;
  columnSettings$: Observable<ColumnSetting[]>;


  dataSource = new MatTableDataSource(ELEMENT_DATA);

  constructor(private router: Router,
    private route: ActivatedRoute, private systemService: SystemService, private siteService: CompanysitesService) {
    let params = this.route.snapshot.params;

    this.siteData$ = this.siteService.getSiteById(params['siteId']).pipe(map(value => {
      return {
        name: value.data()['name'],
        siteId: params['siteId'],
        isDepartmentActive: value.data()['isDepartmentActive'],
        isProjectActive: value.data()['isProjectActive'],
        isFreetextActive: value.data()['isFreetextActive'],
        strictGroup: value.data()['strictGroup'],
      };
    }))

    this.transactions$ = combineLatest(this.route.parent.params, this.route.params, this.route.queryParams).pipe(switchMap(params => {
      return this.systemService.transactionRecord$(params[0]['siteId'], params[1]['systemId'], params[2]['dateFrom'], params[2]['dateTo']).pipe(map((transactions : any) => {
        return transactions.map(transaction => {
          return {
            ...transaction,
            user: transaction.user ? transaction.user.name : "",
            detailPrice: transaction.discountedPrice ? transaction.discountedPrice : "",
            categories: transaction.categories.join(", ")
          }
        })
      }
      ))
    }))

    this.columnSettings$ = this.siteData$.pipe(map(siteData => {
      const columnSettings: ColumnSetting[] = [

        {
          columnId: 'date',
          name: 'Date'
        },
        {
          columnId: 'machineCode',
          name: 'Machine code',
          hideOnMobile: true
        },
        {
          columnId: 'price',
          name: 'Full price'
        },
        {
          columnId: 'detailPrice',
          name: 'Paid price'
        },
        {
          columnId: 'productName',
          name: 'Product name',
        },
        {
          columnId: 'categories',
          name: 'Category',
          hideOnMobile: true,
        },
        {
          columnId: 'user',
          name: 'User',
          hideOnMobile: true,
        },
        {
          columnId: 'orderID',
          name: 'Order ID',
          hideOnMobile: true,
        }];

      if (siteData.isDepartmentActive) columnSettings.push({
        columnId: 'department',
        name: 'Department',
        hideOnMobile: true,
      })

      if (siteData.isProjectActive) columnSettings.push({
        columnId: 'project',
        name: 'Project',
        hideOnMobile: true,
      })

      if (siteData.isFreetextActive) columnSettings.push({
        columnId: 'freeText',
        name: 'Info',
      })

      columnSettings.push(
        {
          columnId: 'quantity',
          name: 'Quantity',
        },{
          columnId: 'status',
          name: 'Status',
        }
      )

      return columnSettings;
    }))

  }

  ngOnInit() {
  }

}
